module.exports = __webpack_public_path__ + "img/tapioka_amazake.34ebfc5c.jpg";